import { Card, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const MyRamNameTab = ({ memberRamNameData, loading }) => {
  const { i18n } = useTranslation();

  const getText = (en, gu, hi) => {
    if (i18n.language === "gu") return gu;
    if (i18n.language === "hi") return hi;
    return en;
  };

  const rows = [
    {
      en: "Total Books",
      gu: "કુલ પુસ્તકો",
      hi: "कुल पुस्तकें",
      value: memberRamNameData.totalBooks || 0,
    },
    {
      en: "On Hand Books",
      gu: "તેણા પાસે પુસ્તકો",
      hi: "उसके पास किताबें",
      value: memberRamNameData.onHandBooks || 0,
    },
    {
      en: "RAM Name in Books",
      gu: "પુસ્તકોમાં રામ નામ",
      hi: "पुस्तकों में राम नाम",
      value: memberRamNameData.totalRamNameInBooks || 0,
    },
    {
      en: "Digital RAM Name",
      gu: "ડિજિટલ રામ નામ",
      hi: "डिजिटल राम नाम",
      value: memberRamNameData.digitalRamName || 0,
      highlight: true,
    },
    {
      en: "Total RAM Name",
      gu: "કુલ રામ નામ",
      hi: "कुल राम नाम",
      value: memberRamNameData.totalRamName || 0,
      highlight: true,
      total: true,
    },
  ];

  return (
    <>
      <div className="d-none d-md-flex justify-content-center px-3">
        <Card
          className="border-0 shadow-lg rounded-4 w-100"
          style={{ maxWidth: "900px" }}
        >
          <Card.Body className="p-5">
            {loading ? (
              <div className="text-center py-5">
                <Spinner animation="border" variant="primary" />
                <div className="mt-2 text-muted">Loading...</div>
              </div>
            ) : (
              rows.map((item, index) => (
                <Card key={index} className="border-0 shadow-sm rounded-3 mb-2">
                  <Card.Body className="d-flex justify-content-between align-items-center">
                    <div>
                      <div className="fw-semibold fs-6">
                        {getText(item.en, item.gu, item.hi)}
                      </div>
                      <small className="text-muted">
                        {item.hi} / {item.gu}
                      </small>
                    </div>

                    <div className="fw-bold fs-6 text-[#ff4f00]">
                      {Number(item.value).toLocaleString()}
                    </div>
                  </Card.Body>
                </Card>
              ))
            )}
          </Card.Body>
        </Card>
      </div>

      <div className="d-md-none px-2">
        {loading ? (
          <div className="text-center py-4">
            <Spinner animation="border" size="sm" />
            <div className="mt-1 text-muted small">Loading...</div>
          </div>
        ) : (
          rows.map((item, index) => (
            <div
              key={index}
              className="d-flex justify-content-between align-items-center py-2 px-2 border-bottom shadow"
            >
              <div>
                <div className="fw-semibold small">
                  {getText(item.en, item.gu, item.hi)}
                </div>
                <small className="">
                  {item.hi} / {item.gu}
                </small>
              </div>

              <div className="text-[#ff4f00]">
                <p className="fs-6">{Number(item.value).toLocaleString()}</p>
              </div>
            </div>
          ))
        )}
      </div>
    </>
  );
};

export default MyRamNameTab;
